module.exports = __webpack_public_path__ + "img/zhanli3.8fa362fc.jpg";